import { render, staticRenderFns } from "./NewEditSeriePage.vue?vue&type=template&id=7177386c&scoped=true"
import script from "./NewEditSeriePage.vue?vue&type=script&lang=js"
export * from "./NewEditSeriePage.vue?vue&type=script&lang=js"
import style0 from "./NewEditSeriePage.vue?vue&type=style&index=0&id=7177386c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7177386c",
  null
  
)

export default component.exports